import { ipcSend } from '@/common/ipc';
import Image from '@tiptap/extension-image';
import RightMenu from '@/components/RightMenu'
import {postMessage} from "@/common/event";
import {BASE64_PLACEHOLDER, EVENT_CLOSE_IMAGE_ACTION, EVENT_OPEN_IMAGE_ACTION} from "@/Const";
import {imgServer} from "@/components/EditorV2/imgServer";
import { NodeSelection, TextSelection  } from 'prosemirror-state';
import {APP_WEB, isWeb, isWebApp} from "@/electron_interactive";
import message from 'antd/lib/message';
import { t } from 'i18next';
import {generateUUID2, getFileNameWithoutExt} from "@/utils";
import {removeCardImage} from "@model/card";
import global from "@/global";

const ImageResize = Image.extend({
    addAttributes() {
        return {
            src: {
                default: null,
            },
            alt: {
                default: null,
            },
            style: {
                default: 'width: 100%; height: auto; cursor: pointer;',
            },
            highlightImgUrl: {
                default: ''
            },
            ifhidden: {
                default: false,
                renderHTML: attributes => {
                    if (attributes.ifhidden === undefined) {
                        return {};
                    }
                    return {
                        'ifhidden': attributes.ifhidden,
                    };
                },
            }
        };
    },
    addNodeView() {
        return ({ node, editor, getPos,extension }) => {
            const { view, options: { editable }, } = editor;
            let { src, alt, style } = node.attrs;
            if (extension.options.fromCardEdit){
                style = 'width: 100%; height: auto; cursor: pointer;'
            }
            const $container = document.createElement('p');
            $container.dataset.id = generateUUID2();
            const $img = document.createElement('img');
            $container.appendChild($img);
            $img.setAttribute('src', src);
            $img.setAttribute('alt', alt);
            $img.setAttribute('style', style);
            $img.setAttribute('draggable', 'true');
            $img.setAttribute('contenteditable', 'true');
            $img.setAttribute('ifhidden', node.attrs.ifhidden);
            
            if (!editable || APP_WEB)
                return { dom: $img };
            const dotsPosition = [
                'top: -4px; left: -4px; cursor: nwse-resize;',
                'top: -4px; right: -4px; cursor: nesw-resize;',
                'bottom: -4px; left: -4px; cursor: nesw-resize;',
                'bottom: -4px; right: -4px; cursor: nwse-resize;',
            ];
            let isResizing = false;
            let startX, startWidth, startHeight;
            let isChoose = false
            $container.addEventListener('click', () => {
                $container.focus()
                // editor.commands.blur()
                $container.setAttribute('style', `position: relative; border: 1px dashed #6C6C6C; ${style} cursor: pointer;`);
                isChoose = true
                Array.from({ length: 4 }, (_, index) => {
                    const $dot = document.createElement('div');
                    $dot.setAttribute('style', `position: absolute; width: 9px; height: 9px; border: 1.5px solid #6C6C6C; border-radius: 50%; ${dotsPosition[index]}`);
                    $dot.addEventListener('mousedown', e => {
                        e.preventDefault();
                        isResizing = true;
                        startX = e.clientX;
                        startWidth = $container.offsetWidth;
                        startHeight = $container.offsetHeight;
                        const onMouseMove = (e) => {
                            if (!isResizing)
                                return;
                            const deltaX = e.clientX - startX;
                            const aspectRatio = startWidth / startHeight;
                            const newWidth = startWidth + deltaX;
                            let nMaxWidth = view.docView.dom.clientWidth - 16;
                            // const txtAreaTitle = document.getElementById('NOTE_TITLE_INPUT');
                            // if (txtAreaTitle){
                            //     nMaxWidth = txtAreaTitle.offsetWidth - 24;
                            // }
                            if(newWidth >nMaxWidth) return
                            const newHeight = newWidth / aspectRatio;
                            $container.style.width = newWidth + 'px';
                            $container.style.height = newHeight + 'px';
                            $img.style.width = newWidth + 'px';
                            $img.style.height = newHeight + 'px';
                            //@ts-ignore
                            window.closeImgAction()
                            postMessage(EVENT_CLOSE_IMAGE_ACTION)
                        };
                        const onMouseUp = () => {
                            if (isResizing) {
                                isResizing = false;
                            }
                            if (typeof getPos === 'function') {
                                const newAttrs = Object.assign(Object.assign({}, node.attrs), { style: `${$img.style.cssText}` });
                                view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, newAttrs));
                            }
                            document.removeEventListener('mousemove', onMouseMove);
                            document.removeEventListener('mouseup', onMouseUp);                
                        };
                        document.addEventListener('mousemove', onMouseMove);
                        document.addEventListener('mouseup', onMouseUp);
                    });
                    $container.appendChild($dot);
                });
                setTimeout(()=>{
                    const divScrollTop = editor.view.dom.parentElement?.parentElement?.scrollTop;
                    //@ts-ignore
                    // window.openImgAction({el:$container,id: src.slice(7,-5),scrollTop:divScrollTop})
                    let szSrc = src;
                    if (szSrc.indexOf('http') == 0){
                        szSrc = imgServer.getLocalImage(src);
                    }
                    if (!szSrc){
                        szSrc = src;
                    }
                    const szFileName = szSrc.replace('atom://','');
                    const szId = getFileNameWithoutExt(szFileName);

                    postMessage(EVENT_OPEN_IMAGE_ACTION,{el:$container,id: szId,fileName:szFileName, scrollTop:divScrollTop,elementId:editor?.id,onDelete:()=>{
                            if (typeof getPos === 'function') {
                                const pos = getPos();
                                const { state, dispatch } = view;
                                const nodeSize = node.nodeSize;
                                const tr = state.tr.delete(pos, pos + nodeSize);
                                // 删除后，光标应该在原图片位置（现在是下一个节点的位置）
                                const newPos = Math.min(pos, tr.doc.content.size);
                                if (newPos >= 0) {
                                    try {
                                        const $pos = tr.doc.resolve(newPos);
                                        // 使用 bias 1 表示优先向后查找（即图片下面一行）
                                        tr.setSelection(TextSelection.near($pos, 1));
                                    } catch (err) {
                                        // 如果设置选择失败，至少完成删除
                                    }
                                }
                                dispatch(tr);
                                // 延迟执行 focus 确保 DOM 更新完成
                                setTimeout(() => {
                                    editor.commands.focus();
                                }, 10);
                            }
                        }})
                    // window.openImgAction({ el: $container, id: src.slice(7, -5) })
                },1)

            });
            
            $img.addEventListener('dblclick', () => {
                // alert('a')
                //@ts-ignore
                window.GpreviewImg(src)
            });
            
            $img.addEventListener('error', (e) => {
                if (isWeb()){
                    $img.src= BASE64_PLACEHOLDER;//"atom://note-place-img.jpeg"
                }else{
                    $img.src= "atom://note-place-img.jpeg"
                }
            });


            let $dom = document.querySelector('#NOTE_V2_DOM');
            if (!$dom){
                $dom = document.querySelector('#cardedit-container-'+editor?.id)
            }
            if (!$dom){
                $dom = document.querySelector(".editor-container------");
            }
            if (!$dom){
                //pagecard中的
                $dom = document.querySelector("#div-editor-scroll-container");
            }
            const clickEvent = (e)=>{
                if (!$container.contains(e.target) && !document.querySelector('#IMG_ACTION')?.contains?.(e.target) ) {
                    $container.removeAttribute('style');
                    isChoose = false
                    if ($container.childElementCount > 2) {
                        for (let i = 0; i < 4; i++) {
                            $container.removeChild($container.lastChild);
                        }
                    }
                    postMessage(EVENT_CLOSE_IMAGE_ACTION);
                    window.closeImgAction?.()
                }else{
                    // window.GEditor.commands.blur()

                }

            }
            $dom?.addEventListener?.('click', clickEvent);
            $img?.addEventListener?.('keydown',(e)=>{
                // console.log('e: ', e);
                if(isChoose){
                    /** 回车 */
                    if(e.keyCode === 13){
                        // const p = document.createComment('p')
                        // p.innerHTML='asdf'
                        // $container.outerHTML = $container.outerHTML + `<p></p>`
                        // p.insertAfter
                        // $container.parentNode.appendChild(p)
                        // // console.log('$container: ', $container);
                        // // console.log('----');
                        // p.focus()
                        editor?.commands.focus()
                    }
                    /** 删除 */
                    if(e.keyCode === 8 || e.keyCode === 46){
                        editor.isCardDeleteImage = true;

                        setTimeout(()=>{
                            $img.width = $img.height = 0;
                            $img.remove();

                            if ($img.src?.startsWith('atom://')){
                                removeCardImage($img.src.replace('atom://',''))
                            }

                            $container.remove()
                            editor?.commands.focus()
                        },10)

                        if (window.closeImgAction){
                            window.closeImgAction();
                        }

                        // 通过编辑器命令正确删除图片节点
                        if (typeof getPos === 'function') {
                            const pos = getPos();
                            const { state, dispatch } = view;
                            const nodeSize = node.nodeSize;
                            const tr = state.tr.delete(pos, pos + nodeSize);
                            // 删除后，光标应该在原图片位置（现在是下一个节点的位置）
                            // 使用 pos 作为目标位置，TextSelection.near 会自动找到最近的有效文本位置
                            const newPos = Math.min(pos, tr.doc.content.size);
                            if (newPos >= 0) {
                                try {
                                    const $pos = tr.doc.resolve(newPos);
                                    // 使用 bias 1 表示优先向后查找（即图片下面一行）
                                    tr.setSelection(TextSelection.near($pos, 1));
                                } catch (err) {
                                    // 如果设置选择失败，至少完成删除
                                }
                            }
                            dispatch(tr);
                            // 延迟执行 focus 确保 DOM 更新完成
                            setTimeout(() => {
                                editor.commands.focus();
                            }, 10);
                        }
                    }
                    if(e.ctrlKey && e.key ==='c'){
                        ipcSend('copy-img', src.slice(7,-5))
                        message.info(t("Has copyed"))
                    }
                }               

            })
            
            return {
                dom: $container,
            };
        };
    },
});

export { ImageResize, ImageResize as default };
//# sourceMappingURL=index.js.map
